/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAssetTypeSubsystemComponentclassResponseDtoShort
 */
export interface GetAssetTypeSubsystemComponentclassResponseDtoShort {
    /**
     * 
     * @type {string}
     * @memberof GetAssetTypeSubsystemComponentclassResponseDtoShort
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetAssetTypeSubsystemComponentclassResponseDtoShort
     */
    assetTypeSubsystemId: string;
    /**
     * Code of the subsystem
     * @type {string}
     * @memberof GetAssetTypeSubsystemComponentclassResponseDtoShort
     */
    subsystemCode: string;
    /**
     * Code of the asset type
     * @type {string}
     * @memberof GetAssetTypeSubsystemComponentclassResponseDtoShort
     */
    assetTypeCode: string;
    /**
     * Count of associated component classes
     * @type {number}
     * @memberof GetAssetTypeSubsystemComponentclassResponseDtoShort
     */
    associatedComponentClassCount: number;
    /**
     * 
     * @type {Date}
     * @memberof GetAssetTypeSubsystemComponentclassResponseDtoShort
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetAssetTypeSubsystemComponentclassResponseDtoShort
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the GetAssetTypeSubsystemComponentclassResponseDtoShort interface.
 */
export function instanceOfGetAssetTypeSubsystemComponentclassResponseDtoShort(value: object): value is GetAssetTypeSubsystemComponentclassResponseDtoShort {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('assetTypeSubsystemId' in value) || value['assetTypeSubsystemId'] === undefined) return false;
    if (!('subsystemCode' in value) || value['subsystemCode'] === undefined) return false;
    if (!('assetTypeCode' in value) || value['assetTypeCode'] === undefined) return false;
    if (!('associatedComponentClassCount' in value) || value['associatedComponentClassCount'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function GetAssetTypeSubsystemComponentclassResponseDtoShortFromJSON(json: any): GetAssetTypeSubsystemComponentclassResponseDtoShort {
    return GetAssetTypeSubsystemComponentclassResponseDtoShortFromJSONTyped(json, false);
}

export function GetAssetTypeSubsystemComponentclassResponseDtoShortFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAssetTypeSubsystemComponentclassResponseDtoShort {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'assetTypeSubsystemId': json['assetTypeSubsystemId'],
        'subsystemCode': json['subsystemCode'],
        'assetTypeCode': json['assetTypeCode'],
        'associatedComponentClassCount': json['associatedComponentClassCount'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function GetAssetTypeSubsystemComponentclassResponseDtoShortToJSON(json: any): GetAssetTypeSubsystemComponentclassResponseDtoShort {
    return GetAssetTypeSubsystemComponentclassResponseDtoShortToJSONTyped(json, false);
}

export function GetAssetTypeSubsystemComponentclassResponseDtoShortToJSONTyped(value?: GetAssetTypeSubsystemComponentclassResponseDtoShort | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assetTypeSubsystemId': value['assetTypeSubsystemId'],
        'subsystemCode': value['subsystemCode'],
        'assetTypeCode': value['assetTypeCode'],
        'associatedComponentClassCount': value['associatedComponentClassCount'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

